// Single source of truth for runtime configuration. Reads window.__ENV__
// (injected by /env.js, generated at container start from APP_* env vars).
// Falling back to Vite env only happens for local `vite dev` outside Docker.

const env = typeof window !== "undefined" ? window.__ENV__ : undefined;

function pick(key: keyof Window["__ENV__"], fallback = ""): string {
  return env?.[key] || (import.meta.env?.[`VITE_${key}`] as string) || fallback;
}

export const config = {
  appEnv: pick("APP_ENV", "local"),
  ssoAuthority: pick("APP_SSO_AUTHORITY"),
  ssoClientId: pick("APP_SSO_CLIENT_ID"),
  ssoKnownAuthorities: pick("APP_SSO_KNOWN_AUTHORITIES")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean),
  ssoScopes: pick("APP_SSO_SCOPES")
    .split(" ")
    .map((s) => s.trim())
    .filter(Boolean),
  consentApiBaseUrl: pick("APP_CONSENT_API_BASE_URL", "http://localhost:8082").replace(/\/+$/, ""),
  appInsightsConnectionString: pick("APP_APPLICATIONINSIGHTS_CONNECTION_STRING"),
};

export type AppConfig = typeof config;
